const endpoints = {
    //baseAddr: "http://localhost:8080/",
    baseAddr: process.env.REACT_APP_API_URL,
    login: "user/login",
    user: "user",
    product: "product",
    importer: "importer",
    exporter: "exporter",
    fininstitution: "fininstitution",
    receiving: "recebimento",
    sale: "venda",
    acc: "acc",
    email: "email"
}

export default endpoints;